import React, { useEffect, useState } from "react";
import { Table } from "../../components/Table/Table";
import {
  active_img,
  deactive_img,
  delete_icon,
  edit_icon,
  eye_icon,
  password_icon,
  search_icon,
  toggle_off,
  toggle_on,
  view_icon,
} from "../../assets/imgs";
import { useNavigate } from "react-router-dom";
import { admin_list, user_review_list } from "../redux/api/dummyJson";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import StarIcon from "@mui/icons-material/Star";
import Swal from "sweetalert2";
import moment from "moment";
import { useLazyPropertiesBlockedDropQuery, useLazyReviewListDeleteQuery, useLazyReviewListStatusQuery, useLazyTotalLocationsListQuery, useReviewListMutation, useReviewListStatusMutation } from "../redux/api/api";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomSearchSelect from "../../components/Searchbox/CustomSearch";
import { Spinner } from "react-bootstrap";

const OwnerReviews = () => {
  const navigate = useNavigate();
  const [deletePopup, setDeletePopup] = useState(false);
  const [loader, setLoader] = useState(false);
  const [list, setList] = useState([]);
  const [pageno, setPageno] = useState(1);
  const [count, setCount] = useState()
  const [pagecount, setPagecount] = useState("");
  const [selectedCityId, setSelectedCityId] = useState('');
  const [selectedPropertyId, setSelectedPropertyId] = useState('');
  const [cities, setCities] = useState([]);
  const [properties, setProperties] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [fromdate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [search, setSearch] = useState("");
  const [locationLoader, setLocationLoader] = useState(false);
  const rolePermissions = JSON.parse(localStorage.getItem('permissions'))

  const [UserReviewsApi] = useReviewListMutation();
  const [getCityApi] = useLazyTotalLocationsListQuery();
  const [getPropertyApi] = useLazyPropertiesBlockedDropQuery()
  const [reviewListDelete] = useLazyReviewListDeleteQuery()
  const [reviewListStatus] = useReviewListStatusMutation();

  const reviewList = (fromdate,
    toDate,
    selectedCityId,
    selectedPropertyId,
    search,
    pageno,) => {
    setLoader(true)
    const formdata = new FormData();
    if (fromdate && toDate) {
      formdata.append('from_date', moment(fromdate).format('YYYY-MM-DD'))
      formdata.append('to_date', moment(toDate).format('YYYY-MM-DD'))
    }
    if (selectedPropertyId) {
      formdata.append('property_id', selectedPropertyId)
    }
    if (selectedCityId) {
      formdata.append('city', selectedCityId)
    }
    if (search) {
      formdata.append('search', search)
    }
    formdata.append("type", 2)
    formdata.append("page", pageno)
    formdata.append("row", 10)
    setFromDate(fromdate);
    setToDate(toDate);
    setSelectedPropertyId(selectedPropertyId);
    setSelectedCityId(selectedCityId);
    setSearch(search);
    UserReviewsApi(formdata)
      .unwrap()
      .then((res) => {
        setLoader(false)
        console.log("res", res);
        let temp = []
        res?.reviews?.map((item, ind) => {
          let obj = { ...item }
          obj.current_page = res?.pagination?.current_page
          temp.push(obj)
        })
        setList(temp);
        // setList(res?.reviews);
        setCount(res?.pagination?.total);
        setPagecount(res?.pagination)
      })
      .catch((err) => {
        console.log("err", err);
      })
  }

  useEffect(() => {
    getLocations()
    getProperty()
    reviewList(fromdate,
      toDate,
      selectedPropertyId,
      selectedCityId,
      search,
      pageno,)
  }, [pageno])

  const getLocations = () => {
    setLocationLoader(true)
    getCityApi()
      .unwrap()
      .then((res) => {
        setLocationLoader(false)
        console.log(res);
        let temp = res?.data?.filter((item) => item?.type == 3);
        setCities(temp);
      })
      .catch((err) => {
        console.error(err);
      });
  };


  const getProperty = () => {
    getPropertyApi()
      .unwrap()
      .then((res) => {
        console.log(res);
        const formattedProperties = res?.data
        // const formattedProperties = res?.data?.map((propertyName, index) => ({
        //     value: propertyName?.name,
        //     label: propertyName?.name,
        //     name: propertyName?.name,
        // })) || [];
        setProperties(formattedProperties);


      })
      .catch((err) => {
        console.error(err);
      });
  };

  const reviewStatus = (id, value) => {
    const formdata = new FormData();
    formdata.append("id", id)
    formdata.append("status", value)
    reviewListStatus(formdata)
      .unwrap()
      .then((res) => {
        console.log("reasds", res);
        if (res?.status == "success") {
          toast.success(res?.message);
          reviewList(fromdate,
            toDate,
            selectedCityId,
            selectedPropertyId,
            search,
            1)
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
  }
  const reviewDelete = () => {
    setDeletePopup(true)
    reviewListDelete(deleteId)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        if (res?.status == "success") {
          toast.success(res?.message);
          setDeletePopup(false);
          reviewList(fromdate,
            toDate,
            selectedPropertyId,
            selectedCityId,
            search,
            1,);
        } else if (res?.status == "error") {
          setDeletePopup(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
  }

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
        },
      },
      {
        Header: "Booking ID",
        accessor: "booking",
        Cell: ({ value, row }) => {
          return <p >{value?.booking_id}</p>;
        },
      },
      {
        Header: "Property Name",
        accessor: "property",
        Cell: ({ value, row }) => {
          return <div className="d-flex ac-jc"> <p className='pointer hoverline' onClick={() => navigate("/property-view", { state: { data: row?.original?.property } })}>{value?.name}</p></div>
        },
      },
      {
        Header: "Owner Name",
        accessor: "",
        Cell: ({ value, row }) => {
          return <div className="d-flex ac-jc"> <p className="pointer hoverline" onClick={() => navigate("/owner-view", { state: { type: "view", id: row?.original?.property?.owner_id } })}>{row?.original?.property?.owner}</p></div>
        },
      },
      // {
      //   Header: "User Name",
      //   accessor: "reviewer",
      //   Cell: ({ value, row }) => {
      //     return <p>{value?.name}</p>;
      //   },
      // },
      {
        Header: "Description",
        accessor: "review",
        Cell: ({ value, row }) => {
          const wordLimit = 5;
          const truncated = value ? value.split(" ").slice(0, wordLimit).join(" ") + (value.split(" ").length > wordLimit ? "..." : "") : "Null";
          return <p>{truncated}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>

              {rolePermissions?.includes('CAN-STATUS-REVIEWS') &&
                <select
                  value={value}
                  onChange={(e) => { reviewStatus(row.original.id, e.target.value) }}
                  className={`fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 ${value == 2 ? "active-btn" : value == 3 ? "suspend-btn" : "blocked-btn"}`}
                >
                  <option className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={2}>
                    Active
                  </option>
                  <option className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={3} >
                    Deactive
                  </option>
                  <option disabled className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={1} >
                    Requested
                  </option>
                </select>
              }
            </React.Fragment>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc">
                {rolePermissions?.includes('CAN-VIEW-REVIEWS') &&
                  <button
                    onClick={() =>
                      navigate("/review", {
                        state: { data: row.original.id, routeType: "Owner" },
                      })
                    }
                    className="cust-btn "
                  >
                    <img src={view_icon} alt="" className="mx-2 edit-btn " />
                  </button>}
                {rolePermissions?.includes('CAN-DELETE-REVIEWS') &&
                  <button onClick={() => { setDeletePopup(row.original.id); setDeleteId(row.original.id) }} className="cust-btn ">
                    <img src={delete_icon} alt="" className="mx-2 edit-btn " />
                  </button>}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    []
  );

  const deleteReview = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          icon: "success",
        });
      }
    });
  };

  useEffect(() => {
    setList(user_review_list);
  }, []);

  return (
    <div className="dashRightView home_section">
      <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
        Review - Owner
      </h2>
      {deletePopup && (
        <div className='img-popup-design'>
          <div className='img-popup'>
            <p className="f3 ms-2 mt-1 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setDeletePopup(false)} className="no-btn">
                No
              </button>
              <button
                onClick={() => {
                  reviewDelete(deletePopup);
                }}
                className="yes-btn f2"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <div className='d-flex ac-js gap-2 flex-wrap'>
        <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap" >From Date</label>
        <div className="w-15">
          <DatePicker
            selected={fromdate}
            onChange={(e) => {
              reviewList(
                e,
                toDate,
                selectedCityId,
                selectedPropertyId,
                search,
                1,
              )
            }}
            dateFormat="dd-MM-yyyy"
            className="input-pop-new ps-2 w-100"
            placeholderText="From Date"
            type="date"
          />
        </div>
        <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap" >To Date</label>
        <div className="w-15">
          <DatePicker
            type="date"
            dateFormat="dd-MM-yyyy"
            className="input-pop-new ps-2 w-100"
            placeholderText="To Date"
            selected={toDate}
            onChange={(e) =>
              reviewList(fromdate, e, selectedCityId, selectedPropertyId, search, 1)
            }
          />
        </div>
        <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap" >City</label>
        <CustomSearchSelect
          options={cities}
          value={selectedCityId}
          locationLoader={locationLoader}
          onChange={(value) => {
            reviewList(fromdate, toDate, value, selectedPropertyId, search, 1);
          }}
          placeholder="Select City"
          width="200px"
        />
        <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap">
          Search
        </label>
        <div className="search-input ">
          <input
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
            value={search}
            onChange={(e) =>
              reviewList(
                fromdate,
                toDate,
                selectedCityId,
                selectedPropertyId,
                e.target.value,
                1,
              )
            }
          />
          <img src={search_icon} className="search" />
        </div>
        <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap" >Property </label>
        <CustomSearchSelect
          options={properties}
          value={selectedPropertyId}
          onChange={(value) => {
            setSelectedPropertyId(value);
            reviewList(
              fromdate,
              toDate,
              selectedCityId,
              value,
              search,
              1,
            );
          }}
          placeholder="Select Property"
          width="200px"
        />

      </div>
      <Table
        columns={columns}
        data={list}
        setPageno={setPageno}
        pagecount={pagecount}
        show={true}
      />
      {loader && (<div style={{ zIndex: 2000, position: "fixed", top: "45%", left: "49%", }}  >
        <Spinner animation="border" className="primary1" />
      </div>
      )}
    </div>
  );
};

export default OwnerReviews;
